import { render, staticRenderFns } from "./TenantDetailsHeader.vue?vue&type=template&id=169f1a36"
import script from "./TenantDetailsHeader.vue.ts?vue&type=script&lang=ts&external"
export * from "./TenantDetailsHeader.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports